<template>
  <div id="app" class="app-main">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>

  </div>
</template>

<script>
   export default {
        data () {
            return {
                theme: this.$store.state.app.themeColor
            };
        },
        mounted () {
        },
        beforeDestroy () {

        },
        methods: {

        }
    };
</script>

<style lang="less">
@import url('./assets/font/iconfont.css');
html,body{
    width: 100%;
    height: 100%;
    background: #F2F7FC;
    overflow: hidden;
}
.app-main{
    width: 100%;
    height: 100%;
    overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue